import PropTypes from 'prop-types'

/** How wide a page's content column is allowed to get. */
export const PAGE_WIDTH = 840

/** The narrower column the signed out screens read at. */
export const AUTH_WIDTH = 600

/** Width of the column in pixels, or `false` to let it fill the screen. */
export const widthPropType = PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([false])])

/**
 * Caps a `Container` at the column width, or leaves it full-bleed. Written as an `sx`
 * entry rather than `maxWidth`, which only takes breakpoint keys.
 *
 * @param {number|false} width - The column width.
 * @returns {object|false} An `sx` entry, or `false` for no cap.
 */
export const columnWidth = (width) => width !== false && { maxWidth: width }

/**
 * How a screen's back control behaves.
 *
 * `false` for a destination with nothing behind it. An object for a screen that has a way
 * back: `onBack` for a flow that keeps its position in state rather than in the URL,
 * `to`/`replace` for the rare screen that must go somewhere fixed. Omitted means pop the
 * history stack, which is right for almost every screen.
 */
export const backPropType = PropTypes.oneOfType([
  PropTypes.oneOf([false]),
  PropTypes.shape({
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    replace: PropTypes.bool,
    onBack: PropTypes.func,
  }),
])
